/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycProcessDto } from '../../models/kyc-process-dto';

export interface GetById3$Params {
  id: string;
}

export function getById3(http: HttpClient, rootUrl: string, params: GetById3$Params, context?: HttpContext): Observable<StrictHttpResponse<KycProcessDto>> {
  const rb = new RequestBuilder(rootUrl, getById3.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycProcessDto>;
    })
  );
}

getById3.PATH = '/kyc/processes/{id}';
